import { useTranslation } from "react-i18next";
import shieldGreen from "@base/assets/images/ic-shield-green.png";
import { ISpecialPackage } from "@base/modules/patientSpecialPackage/patientSpecialPackage.interface";

interface IProps {
  specialPackage: ISpecialPackage;
  size?: number;
}

/** The green shield of a package sold by an insurer (`seller = INSURANCE`); nothing for any other package. */
export default function InsuranceBadge({ specialPackage, size = 22 }: IProps) {
  //! state
  const { t } = useTranslation();

  //! render
  if ((specialPackage.seller ?? "").trim().toUpperCase() !== "INSURANCE") {
    return null;
  }

  return (
    <img
      className="shrink-0"
      src={shieldGreen}
      width={size}
      height={size}
      alt={t("booking.insurancePackage")}
      title={t("booking.insurancePackage")}
    />
  );
}
